
function aboref(){

    //get ref from url 
    var url = new URL(window.location);
    var ref = url.searchParams.get("ref");
    if (ref){
        //set in cookie
        setCookie("aboref",ref, 21);
        extentLinks(ref);
    }else{

        var ref = getCookie("aboref");
        if (ref) {
            extentLinks(ref);
        }else{
            url = location.href.substring(location.href.lastIndexOf('/') + 1);
            if (url.indexOf("abonnement-") != -1){
                ref = url.replace("abonnement-", "");
                setCookie("aboref",ref, 21);
            }
        }
    }
}


function extentLinks(ref){

    var links = document.getElementsByTagName('a');
    for(var i = 0; i< links.length; i++){
        if (links[i].href.indexOf("aanmeldenabonnement.littlecreations.nl") != -1){
            if (links[i].href.indexOf("ref=") == -1 ){
                if (links[i].href.indexOf("?") == -1){
                    links[i].href = links[i].href + "?ref=" + ref;
                }else{
                    links[i].href = links[i].href + "&ref=" + ref;
                }
            }
        }
    }

}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

(function () {
    aboref();
})();